import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { EVestaAsset } from '~config/types';

import { queryOptions } from '../_constants';
import { useSession } from '../useSession';

export const DashboardIntervalValues = ['Week', 'Month', 'Year', 'All'] as const;

export type DashboardInterval = (typeof DashboardIntervalValues)[number];
export const QueryKeyDashboard = 'dashboard-stats';

export interface DashboardStat {
  id: number;
  stats: {
    accruedFees: { [index: string]: string };
    tvl: {
      collaterals: { [index in EVestaAsset]: { collateralLocked: string; collateralLockedUSD: string } };
      tvlUsd: string;
    };
    vstMinted: {
      collaterals: { [index in EVestaAsset]: { vstMinted: string } };
      totalVSTMinted: string;
    };
    vstPrice: string;
  };
  timestamp: string;
}

export const useDashboardStats = (interval: DashboardInterval) => {
  const { network } = useSession();

  const res = useQuery<DashboardStat[]>(
    [QueryKeyDashboard, network.networkId, interval],
    async () => {
      const selectedInterval = interval.toLowerCase();
      const res = await axios.get('/api/data-dashboard?interval=' + selectedInterval);
      return res.data;
    },
    queryOptions(false, true),
  );

  return { ...res, data: res.data ?? [] };
};
